import { useLocal } from '@/i18n/LocalContext'
import './receive.scss'
import CommonModal from '../CommonModal/CommonModal'
import Prop from '../Prop/Prop'

interface ReceiveProps {
  open: boolean
  text?: string
  propList: RewardViewList
  onClose: () => void
  pending?: boolean
}
export default function Receive(props: ReceiveProps) {
  const { open, propList, onClose, pending } = Object.assign<
    Partial<ReceiveProps>,
    ReceiveProps
  >(
    {
      open: false,
      propList: [],
      pending: false,
    },
    props
  )

  const { $t } = useLocal()

  return (
    <CommonModal
      type="receive"
      open={open}
      title={$t('恭喜获得')}
      onClose={onClose}
    >
      {[
        <div key="1" className="receive">
          <ul className="receive-prop-list">
            {pending ? (
              <div className="__onemt__loader-box">
                <div className="__onemt__loader"></div>
              </div>
            ) : (
              propList.map((reward, i) =>
                !reward.icon ? null : (
                  <li key={i} className="receive-prop">
                    <Prop
                      level={reward.level}
                      name={reward.name}
                      imgSrc={reward.icon}
                      count={reward.count}
                      get={false}
                      desc={reward.desc}
                    />
                  </li>
                )
              )
            )}
          </ul>
          <p className="common-modal-text">
            {!props.text
              ? $t(
                  '奖励将通过游戏内邮件发送给您，邮件有效期30天，请您尽快领取！'
                )
              : props.text}
          </p>
        </div>,
        [
          <a key="21" className="common-modal-btn" onClick={onClose}>
            <span>{$t('确定')}</span>
          </a>,
        ],
      ]}
    </CommonModal>
  )
}
